var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
export class ConfirmStore {
    constructor() {
        this.message = "";
        this.open = false;
        makeObservable(this);
    }
    setMessage(msg) {
        this.message = msg;
    }
    setOpen(open) {
        this.open = open;
    }
    setOkCB(cb) {
        this.okcb = cb;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], ConfirmStore.prototype, "message", void 0);
__decorate([
    observable,
    __metadata("design:type", Function)
], ConfirmStore.prototype, "okcb", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ConfirmStore.prototype, "open", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ConfirmStore.prototype, "setMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ConfirmStore.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], ConfirmStore.prototype, "setOkCB", null);
